// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupFileInformation_container__2B7Hw","dataTableContainer":"GroupFileInformation_dataTableContainer__1pDkd","inactive":"GroupFileInformation_inactive__2cBUU"};